<template>
    <div class="py-2 my-3 border-bottom border-top">
        <h2>
            Easybill Artikel
        </h2>
        <div class="row">
            <div class="col-6">
                <template v-for="(val, index) in values">
                    <div class="row">
                        <div class="col-4">
                            <VTextField label="Artikelnummer" v-model="val.easybill_position_number"/>
                        </div>
                        <div class="col-4">
                            <VSelect v-model="val.country_code" :items="availableCountries" item-text="label" item-value="value" label="Land"/>
                        </div>
                        <div class="col-4">
                            <button type="button" class="btn btn-danger ml-4" @click="removeValue(index)"><i class="fas fa-times"></i></button>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <button type="button" class="btn btn-success" @click="values.push(newValue())">
            <span class="mr-2">Neue Position</span><i class="fas fa-plus"></i>
        </button>
        <input :value="JSON.stringify(this.values)" name="easybill_positions" type="hidden">
        <input :value="JSON.stringify(this.deleteValues)" name="delete_easybill_positions" type="hidden">
    </div>
</template>
<script>
export default {
    props: [
        'initValues'
    ],
    data: () => {
        return {
            values: [],
            deleteValues: [],
            availableCountries:[
                {
                    value: 'de',
                    label: 'Deutschland'
                },
                {
                    value: 'at',
                    label: 'Österreich'
                },
                {
                    value: 'ch',
                    label: 'Schweiz'
                },
                {
                    value: 'be',
                    label: 'Belgien'
                }
            ]
        }
    },
    methods: {
        newValue() {
            return {
                id: null,
                country_code: '',
                easybill_position_number: '',
            }
        },
        removeValue(index){
            if(this.values[index].id != null){
                this.deleteValues.push(this.values[index].id);
            }
            this.values.splice(index, 1);
        }
    },
    mounted(){
        if (this.initValues) {
            this.values = JSON.parse(this.initValues);
        } else {
            this.values.push(this.newValue());
        }
    }
}
</script>
<style scoped lang="scss">

</style>
